<template>
  <div class="register">
    <van-nav-bar
      :title="$t('Register.title')"
      left-arrow
      fixed
      @click-left="$router.go(-1)"
    >
      <van-icon
        name="arrow-left"
        slot="left"
        size="20px"
        style="color: #000;"
      />
    </van-nav-bar>
    <van-field
      v-model="name"
      type="name"
      left-icon="static/img/user.png"
      clearable
      :placeholder="$t('Register.name')"
    />
    <van-cell-group>
      <van-field
        readonly
        clickable
        left-icon="static/img/Area_code.png"
        right-icon="arrow"
        :value="areaName"
        :placeholder="$t('ForgetPassword.areaName')"
        @click="showPicker = true"
      />
    </van-cell-group>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        :confirm-button-text="$t('vantText.confirm')"
        :cancel-button-text="$t('vantText.cancel')"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <van-cell-group>
      <van-field
        v-model="phone"
        left-icon="static/img/iphone_num.png"
        :placeholder="$t('ForgetPassword.inputPhone')"
      >
        <button
          class="SMSconfirm"
          slot="button"
          :disabled="isSms"
          @click="sendCode()"
        >
          {{ $t("ForgetPassword.SMS") }}
        </button>
      </van-field>
    </van-cell-group>
    <van-cell-group>
      <van-field
        v-model="smscode"
        left-icon="static/img/Verification.png"
        center
        clearable
        :placeholder="$t('ForgetPassword.inputSMS')"
      >
        <!-- <van-button slot="button" class="smsBtn" size="small" type="primary" :disabled='isSms' @click="sendCode();">发送验证码</van-button> -->
      </van-field>
    </van-cell-group>
    <van-cell-group>
      <van-field
        v-model="password"
        type="password"
        left-icon="static/img/Password.png"
        clearable
        @input="judgePassword()"
        :placeholder="$t('ForgetPassword.setNewPassword')"
      />
    </van-cell-group>
    <van-cell-group>
      <van-field
        v-model="repassword"
        type="password"
        clearable
        left-icon="static/img/Password.png"
        :placeholder="$t('ForgetPassword.certainPassword')"
        @input="judgePassword()"
        :error-message="repasswordJudge"
      />
    </van-cell-group>
    <van-button
      round
      class="smsBtn regBtn"
      size="large"
      type="primary"
      @click="register()"
      >{{ $t("ForgetPassword.submit") }}</van-button
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      areaName: localStorage.getItem("areaName") || "",
      areacode: localStorage.getItem("areacode") || "",
      showPicker: false,
      columns: [],
      phone: "",
      smscode: "",
      name: "",
      password: "",
      repassword: "",
      isSms: false,
      smskey: "",
      repasswordJudge: "",
      getLangs: ""
    };
  },
  mounted: function() {
    this.getAreacode();
    console.log(sessionStorage.getItem("langs"));
    this.getLangs = this.$i18n.locale;
  },
  methods: {
    onConfirm(value, index) {
      this.areacode = this.columns[index].acnumber;
      this.areaName = value.text;
      localStorage.setItem("areacode", this.areacode);
      localStorage.setItem("areaName", this.areaName);
      this.showPicker = false;
    },
    getAreacode() {
      this.$axios({
        method: "get",
        url: this.$build + "/api/areacode"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.columns = res.data.data;
            for (var i = 0; i < this.columns.length; i++) {
              if (this.getLangs == "en") {
                this.columns[i].text =
                  this.columns[i].acname_en +
                  "(" +
                  this.columns[i].acnumber +
                  ")";
              } else if (this.getLangs == "hk") {
                this.columns[i].text =
                  this.columns[i].acname_hk +
                  "(" +
                  this.columns[i].acnumber +
                  ")";
              } else if (this.getLangs == "zh") {
                this.columns[i].text =
                  this.columns[i].acname_cn +
                  "(" +
                  this.columns[i].acnumber +
                  ")";
              } else {
                this.columns[i].text =
                  this.columns[i].acname_en +
                  "(" +
                  this.columns[i].acnumber +
                  ")";
              }
            }
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("ForgetPassword.message")
          });
        });
    },
    sendCode() {
      if (this.areacode && this.phone) {
        this.$axios({
          method: "post",
          url: this.$build + "/api/send",
          data: {
            area_code: this.areacode,
            phone: this.phone
          }
        })
          .then(res => {
            console.log(res);
            if (res.data.status == 200) {
              this.$toast({
                type: "success",
                message: res.data.message
              });
              this.isSms = true;
              this.smskey = res.data.success.key;
              const vm = this;
              setTimeout(function() {
                vm.isSms = false;
                console.log(1111111);
              }, 60000);
            } else {
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              type: "fail",
              message: this.$t("ForgetPassword.message")
            });
          });
      } else {
        this.$toast(this.$t("ForgetPassword.inputAreaNameAndPhone"));
      }
    },
    register() {
      if (!this.smskey) {
        this.$toast(this.$t("ForgetPassword.getSMSkey"));
        return;
      }
      if (
        this.password &&
        this.repassword &&
        this.phone &&
        this.smscode &&
        this.name
      ) {
        this.$axios({
          method: "post",
          url: this.$build + "/api/user/register",
          data: {
            name: this.name,
            key: this.smskey,
            code: this.smscode,
            password: this.password
          }
        })
          .then(res => {
            console.log(res);
            if (res.data.status == 200) {
              this.$toast({
                type: "success",
                message: res.data.message
              });
              const vm = this;
              setTimeout(function() {
                console.log(1111111);
                vm.$router.push("/");
              }, 1500);
            } else {
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              type: "fail",
              message: this.$t("ForgetPassword.message")
            });
          });
      } else {
        this.$toast(this.$t("ForgetPassword.toast"));
      }
    },
    judgePassword() {
      if (this.password == this.repassword) {
        this.repasswordJudge = "";
      } else {
        this.repasswordJudge = this.$t("ForgetPassword.repasswordJudge");
      }
    }
  }
};
</script>
<style scoped>
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  color: #2f75f7;
}
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-field .van-icon {
  font-size: 20px;
}
.register {
  width: 100%;
  height: 100vh;
}
.smsBtn {
  background: #000;
  border: none;
  color: #fff;
  font-weight: bold;
}
.regBtn {
  width: 90%;
  height: 40px;
  line-height: 40px;
  margin-left: 5%;
  margin-top: 25px;
}
.SMSconfirm {
  color: #fff;
  border: none;
  outline: none;
  background-color: #2f75f4;
  font-size: 16px;
  border-radius: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue